<template>
  <component :is="layout" :id="content.id" />
</template>

<script lang="ts" setup>
import type { LandingHeroSection } from '../../../WebsiteBuilder.types'

import LandingHeroLayoutCover from './LandingHeroLayoutCover.vue'

defineProps<{
  content: LandingHeroSection
}>()

// Always use full cover layout regardless of stored layout preference
const layout = LandingHeroLayoutCover
</script>
